import { render, staticRenderFns } from "./proses.vue?vue&type=template&id=39866984"
import script from "./proses.vue?vue&type=script&lang=js"
export * from "./proses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports